<template>
  <div>
    <v-row noGutters>
      <BaseSidebar
        :items="sidebarItems"
        :title="$t('roles.members')"
      />
      <v-col>
        <TeamMembers />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseSidebar from '@/components/shared/navigation/BaseSidebar.vue';
import TeamMembers from '@/components/team/tabs/TeamMembers.vue';
import clientRoles from '@/constants/clientRoles';
import roles from '@/constants/roles';

export default {
    components: {
        TeamMembers,
        BaseSidebar,
    },
    computed: {
        ...mapGetters([
            'team',
        ]),
        sidebarItems() {
            let items = [{
                title: this.$t('roles.all'),
                path: 'team',
            }];

            switch (this.team.teamType) {
                case 'client':
                    items = items.concat(
                        Object.values(clientRoles).map(role => ({
                            title: this.$t(`roles.${role}`),
                            path: `/team/roles/${role}`,
                        })),
                    );
                    break;
                default:
                    items = items.concat(
                        Object.values(roles).map(role => ({
                            title: this.$t(`roles.${role.value}`),
                            path: `/team/roles/${role.value}`,
                        })),
                    );
            }
            return items;
        },
    },
};
</script>
